import * as React from 'react';

import {
  IDeveloperCell,
  IDistrictInfrastructureCell,
  IGalleryCell,
  IInfrastructureCell,
  ILinkCell,
  INewbuildingSummaryCell,
  INewbuildingSummaryCellValue,
  IPriceCell,
  IRoomStatsCell,
  ITextCell,
  ITextListCell,
  ITransportDistanceCell,
  ITransportPointCell,
  ITransportPointExtendedCell,
  TNewbuildingsCompareCell,
  TNewbuildingsCompareRow,
} from '../../../../types/newbuildingsCompare';
import {
  DeveloperCell,
  InfrastructureCell,
  LinkCell,
  NewbuildingSummaryCell,
  NewbuildingSummaryCellFloating,
  RoomStatsCell,
  TextCell,
  TextListCell,
  TransportDistanceCell,
  TransportPointCell,
  TransportPointExtendedCell,
} from './cells';
import { PriceCell } from './cells/PriceCell';
import { GalleryContainer } from '../../../../containers/Gallery';
import { DistrictInfrastructureMapContainer } from '../../../../containers/DistrictInfrastructureMap';

export interface ICellProps {
  type: TNewbuildingsCompareRow['type'];
  cell: TNewbuildingsCompareCell;
  floating?: boolean;
  blockType?: TBlockType;
  withoutBottomPadding?: boolean;
  newbuilding?: INewbuildingSummaryCellValue;
  hasCountText?: boolean;
}

export type TBlockType = 'flats' | 'infrastructure';

export const Cell = ({
  type,
  cell,
  floating,
  blockType,
  newbuilding,
  withoutBottomPadding,
  hasCountText = false,
}: ICellProps): React.JSX.Element | null => {
  switch (type) {
    case 'text':
      return <TextCell cell={cell as ITextCell} />;

    case 'link':
      return <LinkCell cell={cell as ILinkCell} isFlatsBlock={blockType === 'flats'} />;

    case 'textList':
      return (
        <TextListCell
          cell={cell as ITextListCell}
          hasCountText={hasCountText}
          isInfrastructureBlock={blockType === 'infrastructure'}
        />
      );

    case 'gallery':
      return <GalleryContainer cell={cell as IGalleryCell} newbuilding={newbuilding} />;

    case 'valuation':
      return <PriceCell cell={cell as IPriceCell} />;

    case 'developer':
      return <DeveloperCell cell={cell as IDeveloperCell} />;

    case 'roomStats':
      return <RoomStatsCell cell={cell as IRoomStatsCell} withoutBottomPadding={withoutBottomPadding} />;

    case 'infrastructure':
      return <InfrastructureCell cell={cell as IInfrastructureCell} />;

    case 'transportPointExtended':
      return <TransportPointExtendedCell cell={cell as ITransportPointExtendedCell} />;

    // transportPoint и transportDistance приходят только с мобильной ручки.
    case 'transportPoint':
      return <TransportPointCell cell={cell as ITransportPointCell} />;

    case 'transportDistance':
      return <TransportDistanceCell cell={cell as ITransportDistanceCell} />;

    case 'newbuildingSummary':
      return floating ? (
        <NewbuildingSummaryCellFloating cell={cell as INewbuildingSummaryCell} />
      ) : (
        <NewbuildingSummaryCell cell={cell as INewbuildingSummaryCell} />
      );

    case 'districtInfrastructure':
      return (
        <DistrictInfrastructureMapContainer cell={cell as IDistrictInfrastructureCell} newbuilding={newbuilding} />
      );

    default:
      return null;
  }
};
